import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import LabelAndSelectForm from '../form/labelAndSelectForm';

import { getModoOperacaoList } from './selectdbAtions';

class SelectModoOperacao extends Component {
  componentWillMount() {
    this.props.getModoOperacaoList();
  }

  renderOptions() {
    const { list = [], config } = this.props;
    const { usa_adaptativo } = config || {};

    // Filtra a lista se a flag for false
    const filteredList = usa_adaptativo ? list : list.filter(modo => modo.id !== 6 && modo.id !== 7);

    return filteredList.map(modo => (
      <option key={modo.id} value={modo.id}>
        {modo.descricao}
      </option>
    ));
  }

  render() {
    this.renderOptions();
    return (
      <Field
        name={this.props.name}
        component={LabelAndSelectForm}
        label={this.props.label}
        cols={this.props.cols}
        disabled={this.props.disabled}
      >
        <option value="">Selecione</option>
        {this.renderOptions()}
      </Field>
    );
  }
}

const mapStateToProps = state => ({
  list: state.modoOperacaoCon.list,
  config: state.auth.config,
});
const mapDispatchToProps = dispatch => bindActionCreators({ getModoOperacaoList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectModoOperacao);
